// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @ core
const { getLanguage } = require('core/i18n').i18n;
const moment = require('moment');

// @components
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell} = require('commonsComponents/OKTableCell');
const { LabelDate } = require('commonsComponents/labelDate');
const { LABEL_DATE_TODAY, LABEL_DATE_YESTERDAY } = require('constants/commonsComponents');


class cardsControlHistoryTableRow extends React.Component {
    render() {
        const { immTransaction, id } = this.props;
        const timeVal = immTransaction.get('time');
        const dateVal = immTransaction.get('date');
        const language = getLanguage();
        const labelDate = dateVal ? (
            <LabelDate
                date={dateVal}
                language={language}
                today={LABEL_DATE_TODAY}
                yesterday={LABEL_DATE_YESTERDAY}
            />
        ) : '-';
        const labelTime = timeVal ? moment(timeVal, 'HH:mm:ss').format('HH:mm') : '-';

        return (
            <OKTableRow id={id}>
                <OKTableCell>
                    {labelDate}
                </OKTableCell>
                <OKTableCell>
                    {labelTime}
                </OKTableCell>
                <OKTableCell>
                    {immTransaction.get('source', '-')}
                </OKTableCell>
                <OKTableCell>
                    {immTransaction.get('operative', '-')}
                </OKTableCell>
            </OKTableRow>
      );
    }
}

cardsControlHistoryTableRow.propTypes = {
    immTransaction: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired
}

cardsControlHistoryTableRow.defaultProps = {
    id: '0'
}

module.exports = cardsControlHistoryTableRow;
